/* jx-quickadd.js: 2026-10-02 quick add on product cards.
   - "Add" (button[data-qa-add]) posts the variant the card is showing to /cart/add.js, then opens
     the basket drawer (window.JSHOPCart from assets/cart-drawer.js). On the basket page it reloads
     so the page list updates. Any error (sold out, limit) sends the shopper to the product page,
     where the real state is shown.
   - Colour swatch clicks (handled in assets/global.js) also update the card's stock line
     ("Only N left" / "In stock") and its saving badge, from data on the swatch. */
(function () {
  if (window.__jxQuickAdd) return; window.__jxQuickAdd = true;
  var PCT_MIN = 25;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function shownVariant(btn) {
    var card = btn.closest('.product-card');
    var sw = card && card.querySelector('.pc-swatch.is-active[data-pc-variant]');
    return parseInt((sw && sw.getAttribute('data-pc-variant')) || btn.getAttribute('data-qa-variant'), 10);
  }
  function viaOf(btn) {
    if (btn.closest('[data-desk-chair]')) return 'desk-chair';
    if (btn.closest('[data-pair]')) return 'goes-well';
    if (btn.closest('[data-cx], .cx')) return 'cart-pair';
    if (btn.closest('.product-recs, [data-recs], .recently-viewed')) return 'recs';
    return 'quick-add';
  }
  function reset(btn) {
    btn.classList.remove('is-busy', 'is-done'); btn.removeAttribute('aria-busy');
    var l = btn.querySelector('.pc-add__label'); if (l) l.textContent = btn.getAttribute('data-qa-label') || 'Add';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-qa-add]'); if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    var url = btn.getAttribute('data-qa-url') || '/';
    var id = shownVariant(btn);
    if (!id) { window.location.href = url; return; }
    btn.setAttribute('aria-busy', 'true'); btn.classList.add('is-busy');
    var label = btn.querySelector('.pc-add__label');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      // 2026-10-03 (cro, row 19): hidden _via line property, by where the card sits.
      body: JSON.stringify({ items: [{ id: id, quantity: 1, properties: { _via: viaOf(btn) } }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function () {
        btn.classList.remove('is-busy'); btn.classList.add('is-done');
        if (label) label.textContent = 'Added';
        setTimeout(function () { reset(btn); }, 2200);
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        if (window.JSHOPCart && typeof window.JSHOPCart.openWithCart === 'function') window.JSHOPCart.openWithCart({ added: true });
        else window.location.href = root + 'cart';
      })
      .catch(function () { reset(btn); window.location.href = url; });
  });

  // Keep the stock line and the saving badge in step with the chosen colour.
  document.addEventListener('click', function (e) {
    var s = e.target.closest && e.target.closest('.pc-swatch'); if (!s) return;
    var card = s.closest('.product-card'); if (!card) return;
    var stock = card.querySelector('[data-pc-stock]');
    if (stock) {
      var low = parseInt(s.getAttribute('data-pc-low') || '0', 10);
      stock.textContent = low > 0 ? 'Only ' + low + ' left' : 'In stock';
      stock.classList.toggle('is-low', low > 0);
    }
    var b = card.querySelector('[data-pc-badge]');
    if (b && !b.hasAttribute('data-fixed')) {
      var pct = parseInt(s.getAttribute('data-pc-pct') || '0', 10);
      b.classList.remove('pc-badge--pct', 'pc-badge--new');
      if (pct >= PCT_MIN) { b.textContent = pct + '% off'; b.classList.add('pc-badge--pct'); b.hidden = false; }
      else if (b.hasAttribute('data-new')) { b.textContent = 'New'; b.classList.add('pc-badge--new'); b.hidden = false; }
      else { b.textContent = ''; b.hidden = true; }
    }
  });
})();
